export const VARIANT_OPTIONS = ['solid', 'outline', 'faded', 'link', 'ghost'];
// custom (redesign Modeloja): `ink` = the brand primary action color (monochrome ink fill).
// Opt-in only — the default color stays `blue`, so existing buttons are unaffected.
// custom (CRM 2026-06-23): `green` = success/"venda ganha". Exceção sancionada à regra
// brand-only (ink): verde funcional reservado ao estado de VITÓRIA do CRM — botão
// "Concluir venda" e a etapa "Oportunidades Ganhas". Mesmo hex da coluna `won` (#16A34A).
export const COLOR_OPTIONS = [
  'blue',
  'ruby',
  'amber',
  'slate',
  'teal',
  'ink',
  'green',
];
export const SIZE_OPTIONS = ['xs', 'sm', 'md', 'lg'];
export const JUSTIFY_OPTIONS = ['start', 'center', 'end'];

export const EXCLUDED_ATTRS = [
  'variant',
  'color',
  'size',
  'icon',
  'trailingIcon',
  'isLoading',
  ...VARIANT_OPTIONS,
  ...COLOR_OPTIONS,
  ...SIZE_OPTIONS,
  ...JUSTIFY_OPTIONS,
];
